export const JORUDAN_STORE = 'jorudan';
export const JORUDAN_DELETE_FILTER = 'JORUDAN_DELETE_FILTER';
export const JORUDAN_CREATE_FILTER = 'JORUDAN_CREATE_FILTER';
export const JORUDAN_UPDATE_FILTER = 'JORUDAN_UPDATE_FILTER';
